import React from "react";
import { FieldTemplateProps } from "@rjsf/core";

import { CustomFieldTemplateContainer } from "./CustomFieldTemplate.styled";

export const CustomFieldTemplate = ({
  children,
  uiSchema,
}: FieldTemplateProps) => {
  const widget = uiSchema["ui:widget"];

  const isHalfWidth = [
    "ShortTextWidget",
    "DatePickerWidget",
    "PhoneNumberWidget",
  ].includes(widget as string);

  return (
    <CustomFieldTemplateContainer
      className="custom-field-template"
      isHalfWidth={isHalfWidth}
    >
      {children}
    </CustomFieldTemplateContainer>
  );
};
